import { Button } from "flowbite-react";
import { FiRefreshCw } from "react-icons/fi";
import tenkenTheme from "../../configs/themes/tenkenTheme";

const ButtonReset = (props) => {
  const tmpProps = {
    ...props,
    theme: tenkenTheme.button,
    color: "gray",
    className: `rounded-[6px] min-w-[200px] lg:h-10 h-[38px] ${props.className}`,
  };
  const resetPage = () => {
    window.location.reload();
  };

  return (
    <Button onClick={() => resetPage()} {...tmpProps}>
      <FiRefreshCw className="mr-[4px] lg:h-5 lg:w-5 h-[18px] w-[18px]" />
      リセット
    </Button>
  );
};

export default ButtonReset;
